import { simpleFormatDate } from './date';
import { EDateFormats } from '../constants/dates';
import { makeExportRequest } from '../requests/export';

const downloadBlobAsFile = (data: Blob, baseName: string): void => {
  const date = simpleFormatDate(new Date(), EDateFormats.yyyyMMddhhmm);
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');

  const filename = `${baseName}_${date}.csv`;

  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
};

const exportToCSV = async <T>(
  endpoint: string,
  filename: string,
  payload?: T,
): Promise<boolean> => {
  const blob = await makeExportRequest(endpoint, payload);

  if (!blob) return false;

  downloadBlobAsFile(blob, filename);

  return true;
};

export { exportToCSV };
